export interface JourFerie {
  nom: string;
  mois: number; // 1-12 ; 0 pour mobile (Pâques etc.)
  jour: number; // 1-31 ; 0 pour mobile
  mobile?: boolean;
  description?: string;
}

/**
 * Jours fériés gabonais 2026 (et années suivantes).
 * Liste officielle Loi 3/94 + décrets présidentiels.
 */
export const JOURS_FERIES_GABON: readonly JourFerie[] = [
  { nom: 'Jour de l An', mois: 1, jour: 1 },
  { nom: 'Fête du Travail', mois: 5, jour: 1 },
  { nom: 'Fête des Mères', mois: 0, jour: 0, mobile: true, description: 'Dernier dim. mai' },
  { nom: 'Fête des Pères', mois: 0, jour: 0, mobile: true, description: 'Mi-juin' },
  { nom: 'Fête de l Indépendance', mois: 8, jour: 17 },
  { nom: 'Toussaint', mois: 11, jour: 1 },
  { nom: 'Noël', mois: 12, jour: 25 },
  { nom: 'Lundi de Pâques', mois: 0, jour: 0, mobile: true },
  { nom: 'Ascension', mois: 0, jour: 0, mobile: true },
  { nom: 'Pentecôte', mois: 0, jour: 0, mobile: true },
  { nom: 'Aïd el-Fitr', mois: 0, jour: 0, mobile: true, description: 'Fin Ramadan' },
];
